import { PropsWithChildren } from 'react';
import styles from './BottomToolbar.module.css';

export const BottomToolbar: React.FC<PropsWithChildren> = ({ children }) => {
	return <div className={styles.BottomToolbar}>{children}</div>;
};
